export const API_URL =
  process.env.GATSBY_API_URL ?? process.env.API_URL ?? 'https://test-api1.periodica.press/api';
export const PROJECT_API_URL = process.env.PROJECT_API_URL ?? 'https://dev-projects.periodica.press/api';

export const API_VERSION_HEADER = process.env.API_VERSION_HEADER ?? 'v11';

export const headers = { 'Accept-Version': API_VERSION_HEADER, 'Content-Type': 'application/json' };
